package team.platforma.dictionary_domain.model

data class AiChapterDomain(
    val id: Long,
    val name: String
)
